module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"defaultLayouts":{"default":"/home/runner/work/heektime-notice-web/heektime-notice-web/src/components/layout/layout.tsx"},"gatsbyRemarkPlugins":[{"resolve":"gatsby-remark-images","options":{"quality":80,"withWebp":{"quality":80},"withAvif":{"quality":80},"disableBgImageOnAlpha":true,"backgroundColor":"transparent","srcSetBreakpoints":[340,520,890]}}],"extensions":[".mdx"],"lessBabel":false,"remarkPlugins":[],"rehypePlugins":[],"mediaTypes":["text/markdown","text/x-markdown"],"root":"/home/runner/work/heektime-notice-web/heektime-notice-web"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
